import { GENERATE_PRESCRIPTION, PRESCRIPTION_COMMENT } from 'store/diagnoses';

export const getInitValues = (diagnosis = {}) => ({
  [GENERATE_PRESCRIPTION]: diagnosis[GENERATE_PRESCRIPTION] || null,
  [PRESCRIPTION_COMMENT]: diagnosis[PRESCRIPTION_COMMENT] || '',
});
